class Actions {
  static ADD = 'add';
  static REMOVE = 'remove';
}

export { Actions }